import React, { useState } from 'react';
import { UserDto } from '../../../api-client';
import { useRemoveUserFromGroupFacade } from './useRemoveUserFromGroupFacade';

type UseRemoveUserFromGroupModalFacade = (groupId: string) => {
  groupUserToDelete: false | UserDto;
  closeGroupUserDeleteModal: () => void;
  setGroupUserToDelete: React.Dispatch<React.SetStateAction<false | UserDto>>;
  handleRemoveUserFromGroup: <T>(original: T) => void;
  isRemoving: boolean;
};

export const useRemoveUserFromGroupModalFacade: UseRemoveUserFromGroupModalFacade = (groupId) => {
  const [groupUserToDelete, setGroupUserToDelete] = useState<false | UserDto>(false);

  const closeGroupUserDeleteModal = () => setGroupUserToDelete(false);

  const { handleRemoveUserFromGroup, isRemoving } = useRemoveUserFromGroupFacade(
    groupId,
    closeGroupUserDeleteModal,
  );

  return {
    groupUserToDelete,
    closeGroupUserDeleteModal,
    setGroupUserToDelete,
    handleRemoveUserFromGroup,
    isRemoving,
  };
};
